import { FC, useContext, useEffect } from "react";
import {
	BrowserRouter as Router,
	Switch,
	Route,
} from "react-router-dom";

import { AlertMessage, Loader } from "./components/atoms";

import { 
	BoardRoute, 
	LobbyRoute, 
	LoginRoute, 
	SlotmachineRoute, 
	StatisticsRoute, 
	SummaryRoute, 
	SurveyRoute, 
	InitialRoute, 
	GoodbyeRoute
} from "./router";

import useGameData from "./hooks/useGameData";
import "./scss/main.scss";
import DiplomaRoute from "./router/DiplomaRoute";
import ForceRoute from "./router/ForceRoute";
import { SlotMachineDemo } from "./components/organisms";
import { SlotMachineDemoData } from "./components/organisms";
import { SocketContext, TeamContext } from "./context";
import SpectatorRoute from "./router/SpectatorRoute";
import { getUrlTokenExtracted } from "./context/helpers";
import { useTranslation } from "react-i18next";

const App: FC<{}> = () => {
	const { socket, forceRefreshPlayer } = useContext(SocketContext);
	const { roomUsers, game, setGameId, gameId, getGameLanguage, selectedLanguage } = useContext(TeamContext);
	const pathname : string | undefined = window.location.pathname;
	const isPageSlotMachineDemoRendered : boolean = pathname.includes("/slotmachineDemoData");
	const { i18n } = useTranslation();

	const {urlToken} = useGameData();

	useEffect( () => {
		console.log("RoomUsers invoked in App");
		roomUsers();
	}, []);

	useEffect( () => {
		forceRefreshPlayer();
	}, [forceRefreshPlayer]);

	useEffect( () => {
		if(!isPageSlotMachineDemoRendered) {
			getGameLanguage();
			i18n.changeLanguage(selectedLanguage);			
		}
	}, [selectedLanguage])

	useEffect( () => {
		if (!gameId && !isPageSlotMachineDemoRendered) setGameId( getUrlTokenExtracted() );
	}, [gameId, setGameId]);

	if (!urlToken)
		return <Loader />

	console.log("APP");

	const windowLocationHref = window.location.href;
	const urlPathChunks = windowLocationHref.split("/");
	const urlTokenExtracted = urlPathChunks[urlPathChunks.length-1];

	const reconnectByeSocket = () => {
		console.log(" this is socket: ", socket);
		console.log(" gameId: ", gameId);
		if (!gameId) setGameId( getUrlTokenExtracted() );
	}

	return (
		<Router>

			<Switch>
				<Route exact path={`/${urlTokenExtracted}`} component={InitialRoute} />
				<Route exact path={`/logIn/${urlToken}`} component={LoginRoute} />
				<Route exact path={`/joinMidGame/${urlToken}`} component={LoginRoute} />
				<Route exact path={`/lobby/${urlToken}`} component={LobbyRoute} />
				<Route exact path={`/slotmachine/${urlToken}`} component={SlotmachineRoute} />
				<Route exact path={`/slotmachineDemo/${urlToken}`} component={SlotMachineDemo} />
				<Route exact path={`/slotmachineDemoData/data`} component={SlotMachineDemoData} />
				<Route exact path={`/board/${urlToken}`} component={BoardRoute} />
				<Route exact path={`/force/${urlToken}`} component={ForceRoute} />
				<Route exact path={`/spectator/${urlToken}`} component={SpectatorRoute} />
				<Route exact path={`/summary/${urlToken}`} component={SummaryRoute} />
				<Route exact path={`/statistics/${urlToken}`} component={StatisticsRoute} />
				<Route exact path={`/survey/${urlToken}`} component={SurveyRoute} />
				<Route exact path={`/diploma/${urlToken}`} component={DiplomaRoute} />
				<Route exact path={`/goodbye/${urlToken}`} component={GoodbyeRoute} />
				<Route component={InitialRoute} />
			</Switch>

			{/* <div style={{position: "absolute", top: "50px", right: 0 , zIndex: 600}}>
				<button onClick={reConnectToServer}> reConnect </button>
				<button onClick={reconnectByeSocket}> reConnect by SOCKET </button>
				<button onClick={() => console.log("G A M E: ", game) }> print GAME object </button>
				<button onClick={() => console.log("UserData: ", userData) }> print UserData </button>
				{ (game?.phase === Phase.CHOOSE_SOLUTION) ? <span> true </span> : <span> fasle </span>  }
				{ (theSolutionCardSelectedByDilemmaOwner) ? <span> true </span> : <span> fasle </span>  }
				{ (areStrengthsShownFullScreen) ? <span> true </span> : <span> fasle </span>  }
			</div> */}

			<AlertMessage />
		</Router >
	);
};

export default App;